import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import "./UploadModal.css";
import { supabase } from "../supabaseClient";

export const UploadModal = ({ show, onHide }) => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [preview, setPreview] = useState("");
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    nearLocation: "",
  });
  const [suggestions, setSuggestions] = useState([]);
  const [fileData, setFileData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getSupabaseData();
  }, []);

  const getSupabaseData = async () => {
    try {
      const { data, error } = await supabase
        .from('form_responses')
        .select('*');

      if (error) throw error;
      setFileData(data || []);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleFileChange = (event) => {
    if (event.target.files?.[0]) {
      setSelectedFile(event.target.files[0]);
      const objectUrl = URL.createObjectURL(event.target.files[0]);
      setPreview(objectUrl);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));

    if (name === "nearLocation") {
      const query = value.toLowerCase();
      if (query) {
        const results = fileData.filter(
          (item) =>
            (item.title || "").toLowerCase().includes(query) ||
            (item.country || "").toLowerCase().includes(query) ||
            (item.continent || "").toLowerCase().includes(query)
        );
        setSuggestions(results.map((item) => item.title));
      } else {
        setSuggestions([]);
      }
    }
  };

  const handleSuggestionClick = (suggestion) => {
    setFormData((prev) => ({ ...prev, nearLocation: suggestion }));
    setSuggestions([]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!selectedFile) return;

    setLoading(true);
    try {
      const filePath = `images/${selectedFile.name}`;
      const { data: uploadData, error: uploadError } = await supabase.storage
        .from('images')
        .upload(filePath, selectedFile);

      if (uploadError) throw uploadError;

      const { data: { publicUrl } } = supabase.storage
        .from('images')
        .getPublicUrl(filePath);

      const locationResult = fileData.find(
        (item) =>
          (item.title || "").toLowerCase() === formData.nearLocation.toLowerCase()
      );

      const currentImageUrl = locationResult.image_url || [];
      const { error: updateError } = await supabase
        .from('form_responses')
        .update({
          image_url: [
            ...currentImageUrl,
            {
              Name: formData.name,
              Email: formData.email,
              UploadedUrl: publicUrl,
            },
          ],
        })
        .eq('id', locationResult.id);

      if (updateError) throw updateError;

      setFormData({ name: "", email: "", nearLocation: "" });
      setSelectedFile(null);
      setPreview("");
      onHide();
    } catch (error) {
      console.error("Upload error:", error);
    } finally {
      setLoading(false);
    }
  };

  const triggerFileInput = () => {
    document.getElementById("fileInput").click();
  };

  return (
    <Modal show={show} onHide={onHide} size="lg" style={{ marginTop: "100px" }}>
      <Modal.Header closeButton>
        <Modal.Title>Fill the Form</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-6 text-center border-right file-upload-wrapper">
              <div
                id="dropzone"
                className="dropzone"
                onClick={triggerFileInput}
              >
                <p>Drag 'n' drop some files here, or click to select files</p>
                <input
                  type="file"
                  id="fileInput"
                  accept=".png, .jpg, .jpeg"
                  onChange={handleFileChange}
                />
                {preview && (
                  <img
                    src={preview}
                    alt="Preview"
                    id="previewImg"
                    className="preview-image"
                  />
                )}
              </div>
            </div>

            <div className="col-md-6">
              <form id="uploadForm" onSubmit={handleSubmit}>
                <div className="form-group">
                  <label htmlFor="name">Name:</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    required
                    className="form-control"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="email">Email:</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                    className="form-control"
                  />
                </div>

                <div className="form-group search-container">
                  <label htmlFor="nearLocation">Near Location:</label>
                  <input
                    type="text"
                    id="nearLocation"
                    name="nearLocation"
                    value={formData.nearLocation}
                    onChange={handleInputChange}
                    placeholder="search..."
                    required
                    className="form-control"
                  />
                  {suggestions.length > 0 && (
                    <ul className="suggestions-list">
                      {suggestions.map((suggestion, index) => (
                        <li
                          key={index}
                          onClick={() => handleSuggestionClick(suggestion)}
                        >
                          {suggestion}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </form>
            </div>
          </div>
        </div>
      </Modal.Body>

      <Modal.Footer className="justify-content-center">
        <Button
          variant="success"
          type="submit"
          form="uploadForm"
          disabled={loading}
          className="px-5 py-2"
        >
          {loading ? "Uploading..." : "Submit"}
        </Button>
        <Button variant="primary" onClick={onHide} className="px-5 py-2">
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
